<script>
  import {BeginnerMenu} from "@util/constant"
  let {
    ColumnNumber = 2,
    Menu = [
      {
        icon: '',
        iconPath:"",
        href: '',
        sendPCID:'',
        label: '',
        caption: '',
        childMenu: [
          {
            href: '',
            sendPCID:'',
            label: '',
            caption: ''
          }
        ]
      }
    ]
  } = $props();
</script>

<div class="large-service-menu-content">
  <div class="menu menu-column:{ColumnNumber}">
    {#each Menu as menu}
      {#if menu.label !== "セキュリティ" && menu.label !== "ユーザーガイド"}
        <div class="menu-item">
          {#if menu.href}
            <a
              href={menu.href}
              target="{menu.blank ? "_blank" : undefined}"
              id={menu.sendPCID ? menu.sendPCID : undefined}
              class="menu-link-item single"
              >
              <div class="menu-link-item-content">
                <div
                  class={menu.caption ? "menu-link-item-labelblock spacing:bottom:12" : "menu-link-item-labelblock"}
                  style={menu.caption ? "display:grid":"display:block"}
                  data-name={menu.icon}
                  >
                  {#if menu.caption}
                    <span class="menu-link-item-labelblock-icon">
                      <img src={menu.iconPath} alt="{menu.label}のアイコン" />
                    </span>
                  {/if}
                  <p class="menu-link-item-labelblock-label">{menu.label}</p>
                </div>
                {#if menu.caption}
                  <span class="menu-link-item-caption">{menu.caption}</span>
                {/if}
              </div>
              <span class="menu-link-item-icon">
                <img src="/assets_default/icons/chevron_right.svg" alt="詳細ページへ" />
              </span>
            </a>
            {#if menu.label === "みんなの銀行とは"}
            <a class="menu-link-item single" href="{BeginnerMenu[2].href}" id="common-pc-header-firsttime">
              <div class="menu-link-item-content">
                <div class="menu-link-item-labelblock spacing:bottom:12" data-name={BeginnerMenu[2].icon} style="display: grid;">
                  <span class="menu-link-item-labelblock-icon"><img class="" src={BeginnerMenu[2].iconPath} alt="{BeginnerMenu[2].label}のアイコン">
                  </span>
                  <p class="menu-link-item-labelblock-label">{BeginnerMenu[2].label}</p>
                </div>
                <span class="menu-link-item-caption">{BeginnerMenu[2].caption}</span>
              </div>
              <span class="menu-link-item-icon">
                <img src="/assets_default/icons/chevron_right.svg" alt="詳細ページへ" class="">
              </span>
            </a>
            <a class="menu-link-item single" href="{BeginnerMenu[3].href}" id="common-pc-header-firsttime">
              <div class="menu-link-item-content">
                <div class="menu-link-item-labelblock spacing:bottom:12" data-name={BeginnerMenu[3].icon} style="display: grid;">
                  <span class="menu-link-item-labelblock-icon"><img class="" src={BeginnerMenu[3].iconPath} alt="{BeginnerMenu[3].label}のアイコン">
                  </span>
                  <p class="menu-link-item-labelblock-label">{BeginnerMenu[3].label}</p>
                </div>
                <span class="menu-link-item-caption">{BeginnerMenu[3].caption}</span>
              </div>
              <span class="menu-link-item-icon">
                <img src="/assets_default/icons/chevron_right.svg" alt="詳細ページへ" class="">
              </span>
            </a>
            {/if}
          {:else}
            <div class="menu-head">
              {#if menu.iconPath}
              <span class="menu-head-icon">
                <img src={menu.iconPath} alt="{menu.label}のアイコン" />
              </span>
              {/if}
              <p class="menu-head-label">{menu.label}</p>
            </div>
          {/if}

          {#if menu.childMenu && menu.childMenu.length > 0}
            <div class="menu-body">
              <ul class="menu-lists">
                {#each menu.childMenu as child}
                  <li class="menu-list">
                    <a
                      href={child.href}
                      target="{child.blank ? "_blank" : undefined}"
                      id={child.sendPCID ? child.sendPCID : undefined}
                      class="menu-link-item">
                      <div class="menu-link-item-content">
                        <div class="menu-link-item-labelblock" style={child.icon ? "display:grid;":"display:block;"}>
                          {#if child.icon}
                            <span class="menu-link-item-labelblock-icon">
                              <img src={child.iconPath} alt="{child.label}のアイコン" />
                            </span>
                          {/if}
                          <p class={child.caption ? "menu-link-item-labelblock-label spacing:bottom:12" :"menu-link-item-labelblock-label"}>{child.label}</p>
                        </div>
                        {#if child.caption}
                          <span class="menu-link-item-caption">{@html child.caption}</span>
                        {/if}
                      </div>
                      <span class="menu-link-item-icon">
                        <img src="/assets_default/icons/chevron_right.svg" alt="詳細ページへ" />
                      </span>
                    </a>
                  </li>
                {/each}
              </ul>
            </div>
          {/if}
        </div>
      {/if}
    {/each}
  </div>
</div>

<style lang="scss">

  .large-service-menu-content {
    background: #fff;
  }

  .menu {
    display: grid;
    gap: 24px 40px;

    &-column {
      &\:2 {
        grid-template-columns: repeat(2, 1fr);
        gap: 0 40px;
      }
      &\:3 {
        grid-template-columns: repeat(3, 1fr);
      }
    }
  }

  .menu {
    &-head {
      display: grid;
      grid-template-columns: 24px 1fr;
      padding: 16px 4px;
      gap: 8px;
      border-bottom: 1px solid var(--primary-black);
      align-items: center;
      text-decoration: none;
      color: var(--primary-black);

      &-icon {
        display: block;
        height: 24px;
        img {
          width: 100%;
        }
      }
      &-label {
        @include g.owd-typography('text-1');
        font-weight: 600;
        line-height: 1.2;
      }
    }

    &-lists {
      list-style: none;
      padding: 0;
      margin: 0;
    }

  }


  .menu-link-item {
    padding: 24px 8px;
    display: grid;
    grid-template-columns: 1fr 24px;
    text-decoration: none;
    color: var(--primary-black);
    align-items: center;
    transition: .2s linear opacity;
    border-bottom: 1px solid var(--black-opacity1);


    @media (hover: hover) {
      &:hover {
        opacity: .6;
      }
    }


    &.single {
      border-bottom: 1px solid var(--black-opacity1);
      // .menu-link-item-labelblock {
      //   display: block;
      // }
    }

    &-labelblock {
      display: grid;
      grid-template-columns: 24px 1fr;
      gap: 8px;
      align-items: center;
      &-icon {
        width: 100%;
        height: 24px;
        img {
          width: 100%;
        }
      }
      &-label {
        @include g.owd-typography('text-1');
        display: block;
        font-weight: 600;
      }
    }
    &-caption {
      display: block;
      @include g.owd-typography('text-3');
    }


    &-icon {
      width: 100%;
      height: 24px;
      img {
        width: 100%;
      }
    }
  }

</style>
